import { useAction } from '@reatom/npm-react'
import { styled } from 'styled-components'

import { addPairToRecentSearchesAction } from '@root/features/user/recent-searches'
import { CandleChartIcon } from '@root/shared/ui-kit'
import { VirtualList } from '@root/shared/ui-kit/virtual-list'

import { PairSearchItem, PairSearchItemSkeleton } from './search-pair-item'

import type { AsyncStateN } from '@blade/std-lib'
import type { Pair, PairModel } from '@root/entities/pair'
import type { Error } from '@root/shared'

type SearchResultsProps = {
  state: AsyncStateN.AsyncStateN<Error.UnknownError, Array<PairModel>>
  onPairSelected?: (pair: Pair.PairMinimal) => void
}

export const SearchResults: React.FC<SearchResultsProps> = ({
  state,
  onPairSelected,
}) => {
  const addPairToRecentSearches = useAction(addPairToRecentSearchesAction)

  const handlePairSelected = (pair: PairModel) => {
    onPairSelected?.(pair)
    addPairToRecentSearches(pair)
  }

  return (
    <List
      emptyIcon={<CandleChartIcon />}
      getKey={(it) => it.address}
      renderItem={(it) => (
        <PairSearchItem
          key={it.address}
          pair={it}
          onClick={handlePairSelected}
        />
      )}
      renderSkeleton={() => <PairSearchItemSkeleton />}
      state={state}
      skeletonsCount={5}
    />
  )
}

const List = styled(VirtualList<PairModel>)`
  --virtual-list-gap: 4px;
`
